<template>
    <div class="sustainable-component wage-employee-competences">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-employee-competences</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-5">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Anst.nr.</th>
                                <th class="col-4">Förnamn</th>
                                <th class="col-5">Efternamn</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in employees" :key="index">
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.EmployeeNumber}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.EmployeeNumber}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.FirstName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.FirstName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>{{item.LastName}}</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee">{{item.LastName}}</span>
                                </td>
                                <td>
                                    <span v-if="item.EmployeeId == selectedEmployee"><b>vald</b></span>
                                    <span v-if="item.EmployeeId != selectedEmployee"><a href="javascript:void(0)" @click="selectEmployee(item.EmployeeId)">välj</a></span>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-md-7">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-1">BlockNr.</th>
                                <th class="col-2">BlockNamn</th>
                                <th class="col-2">Godkänd</th>
                                <th class="col-2">Nästa steg</th>
                                <th class="col-2">Utveckling</th>
                                <th class="col-2">Kommentar</th>
                                <th class="col-1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in competencies" :key="index">
                                <td>
                                    <span>{{item.BlockNumber}}</span>
                                </td>
                                <td>
                                    <span>{{item.BlockName}}</span>
                                </td>
                                <td>
                                    <span><v-radio v-bind:disabled="disabled" v-model="item.Passed" @click="checkSomething(item,'passed')"></v-radio></span>
                                </td>
                                <td>
                                    <span><v-radio v-bind:disabled="disabled" v-model="item.DevelopNextStage" @click="checkSomething(item,'nextstage')"></v-radio></span>
                                </td>
                                <td>
                                    <span><v-radio v-bind:disabled="disabled" v-model="item.Utveckling" @click="checkSomething(item,'developing')"></v-radio></span>
                                </td>
                                <td class="text-center">
                                    <span v-if="item.Comment != null && item.Comment != ''" style="position:relative"><i style="position:absolute; margin-top:5px" class="mdi mdi-message-outline"></i></span>
                                </td>
                                <td class="col-1">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateComment(item)">Kommentar</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <v-btn v-bind:disabled="disabled" v-if="selectedEmployee != null" size="default" color="primary" class="btn-primary" @click="updateEmployeeCompetencies">
                        Spara kompetens
                    </v-btn>

                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateCompetenceComment v-bind:disabled="disabled" ref="updateCompetenceComment"></UpdateCompetenceComment>

    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import UpdateCompetenceComment from "./update/update-competence-comment.vue"
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance, ref } from 'vue'

    const updateCompetenceComment = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-employee-competences',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
            UpdateCompetenceComment
        },
        methods: {
            updateComment(item) {
                this.loading++;
                this.updateCompetenceComment.open(item);
                this.loading--;
            },
            async updateEmployeeCompetencies() {
                this.loading++;
                try {
                    await WageService.updateEmployeeCompetencies(this.selectedEmployee, this.competencies);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            checkSomething(item, option) {
                item.Passed = false;
                item.DevelopNextStage = false;
                item.Utveckling = false;
                if (option == "passed") {
                    item.Passed = true;
                }
                else if (option == "nextstage") {
                    item.DevelopNextStage = true;
                }
                else if (option == "developing") {
                    item.Utveckling = true;
                }
            },
            getId() {
                return getCurrentInstance().uid;
            },
            async getEmployeesFromJobPosition(selectedPosition) {
                this.loading++;
                try {
                    this.employees = await WageService.getEmployeesFromJobPosition(selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async selectEmployee(employeeId) {
                this.loading++;
                try {
                    this.selectedEmployee = employeeId;
                    this.competencies = await WageService.getCompetenciesFromEmployee(employeeId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            
        },
        data() {
            return {
                competencies:[],
                selectedEmployee: null,
                employees:[],
                selectedPosition:null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getEmployeesFromJobPosition(newVal);
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateCompetenceComment }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
